module.exports = __webpack_public_path__ + "c961ba1b15db19d3f8a56821e2bcf93f.MP3";